import React, { useState, useEffect, useRef } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { toast } from 'react-toastify';
import NftTransferDialog from './NFTTransferDialog';
import CouponManageDialog from './CouponDialog';
// import NftDeleteDialog from './NftDeleteDialog';
import Skeleton from '@material-ui/lab/Skeleton';
import NftsCollectionComponent from './NftsCollectionComponent';
import {
  query,
  doc,
  where,
  getDoc,
  getDocs,
  limit,
  startAfter,
  orderBy,
  collection,
  updateDoc,
  writeBatch,
} from 'firebase/firestore/lite';
import { firebaseFireStore } from '../../config/firebaseFirestore';
import { firebaseAuthFunc } from '../../config/firebaseAuth';
import { skeleTonJson } from '../common/jsonDumb';
import NftNotPublicDialog from './NftNotPublicDialog';
import router from 'next/router';
import NFTReedem from './NFTReedem';
import { Api } from '../../config/api';
import { async } from '@firebase/util';
import InfiniteScroll from 'react-infinite-scroller';
import { useMediaQuery } from '@material-ui/core';
import { redeemNfts } from '@/services/common-query';

let selectedNftIndex = 0;
let startAfterDoc = null;
let backedNftArr = [];

export default function NftsContainer(props) {
  const userWalletRedux = useSelector(
    (state) => state.walletReducer.walletData,
  );
  const userDataRedux = useSelector((state) => state.authReducer.userData);
  const isMobile = useMediaQuery('(max-width:1000px)');

  const [couponDialogState, setcouponDialogState] = useState(false);
  const [nftTransferDialogState, setnftTransferDialogState] = useState(false);
  const [isNftNotPublicDialog, setNftNotPublicDialog] = useState(false);
  const [isNftNotPublicLoading, setNftNotPublicLoading] = useState(false);
  const [redeemModalIsOpened, setRedeemModalIsOpened] = useState(false);
  const [redeemBtnLoading, setRedeemBtnLoading] = useState(false);
  const nftNotPublicDataRef = useRef({ nftIndex: null, nftData: {} });
  const [redeemState, setRedeemState] = useState(false);
  const [walletOwnedNfts, setwalletOwnedNfts] = useState([]); //wallet nfts
  const [loadingNfts, setloadingNfts] = useState(false);
  const [hasMore, sethasMore] = useState(true);

  const token = useSelector((state) => state.authReducer.userauthtoken);

  useEffect(() => {
    if (userDataRedux?.uid && props.type) {
      getWalletNFTs();
    }
  }, [userDataRedux, props.type]);

  useEffect(() => {
    return () => {
      // Executed only when component unmounts,
      startAfterDoc = null;
      backedNftArr = [];
    };
  }, []);

  const getWalletNFTs = async () => {
    try {
      if (!loadingNfts) {
        console.log('get wallet called');
        setloadingNfts(true);
        let nftArr = [...backedNftArr];

        let queryArr = [];
        if (props.type === 'owned') {
          let docObj = startAfterDoc ? startAfterDoc.data() : null;
          queryArr.push(collection(firebaseFireStore, 'musicartNfts'));
          queryArr.push(where('usersId', 'array-contains', userDataRedux.uid));
          queryArr.push(orderBy('creationDate', 'desc'));
          if (docObj) {
            queryArr.push(startAfter(startAfterDoc));
          }
          queryArr.push(limit(8));
        } else if (props.type === 'active') {
          let docObj = startAfterDoc ? startAfterDoc.data() : null;
          queryArr.push(collection(firebaseFireStore, 'musicartNfts'));
          queryArr.push(where('adminState', '==', 'ACCEPT'));
          queryArr.push(where('activeInMarketPlace', '==', true));
          queryArr.push(where('usersId', 'array-contains', userDataRedux.uid));
          queryArr.push(orderBy('creationDate', 'desc'));
          if (docObj) {
            queryArr.push(startAfter(startAfterDoc));
          }
          queryArr.push(limit(8));
        } else if (props.type === 'inactive') {
          let docObj = startAfterDoc ? startAfterDoc.data() : null;
          queryArr.push(collection(firebaseFireStore, 'musicartNfts'));
          queryArr.push(where('adminState', '==', 'ACCEPT'));
          queryArr.push(where('activeInMarketPlace', '==', false));
          queryArr.push(where('usersId', 'array-contains', userDataRedux.uid));
          queryArr.push(orderBy('creationDate', 'desc'));
          if (docObj) {
            queryArr.push(startAfter(startAfterDoc));
          }
          queryArr.push(limit(8));
        } else if (props.type === 'pending') {
          let docObj = startAfterDoc ? startAfterDoc.data() : null;
          queryArr.push(collection(firebaseFireStore, 'musicartNfts'));
          queryArr.push(where('adminState', '==', 'PENDING'));
          queryArr.push(where('usersId', 'array-contains', userDataRedux.uid));
          queryArr.push(orderBy('creationDate', 'desc'));
          if (docObj) {
            queryArr.push(startAfter(startAfterDoc));
          }
          queryArr.push(limit(8));
        } else if (props.type === 'rejected') {
          let docObj = startAfterDoc ? startAfterDoc.data() : null;
          queryArr.push(collection(firebaseFireStore, 'musicartNfts'));
          queryArr.push(where('adminState', '==', 'REJECT'));
          queryArr.push(where('usersId', 'array-contains', userDataRedux.uid));
          queryArr.push(orderBy('creationDate', 'desc'));
          if (docObj) {
            queryArr.push(startAfter(startAfterDoc));
          }
          queryArr.push(limit(8));
        } else if (props.type === 'pending') {
          let docObj = startAfterDoc ? startAfterDoc.data() : null;
          queryArr.push(collection(firebaseFireStore, 'musicartNfts'));
          queryArr.push(where('adminState', '==', 'PENDING'));
          queryArr.push(where('usersId', 'array-contains', userDataRedux.uid));
          queryArr.push(orderBy('creationDate', 'desc'));
          if (docObj) {
            queryArr.push(startAfter(startAfterDoc));
          }
          queryArr.push(limit(8));
        } else if (props.type === 'redeem') {
          let docObj = startAfterDoc ? startAfterDoc.data() : null;
          queryArr.push(collection(firebaseFireStore, 'musicartNfts'));
          queryArr.push(where('usersId', 'array-contains', userDataRedux.uid));
          queryArr.push(orderBy('creationDate', 'desc'));
          if (docObj) {
            queryArr.push(startAfter(startAfterDoc));
          }
          queryArr.push(limit(8));
        } else {
          queryArr.push(collection(firebaseFireStore, 'musicartNfts'));
          queryArr.push(where('adminState', '==', 'ACCEPT'));
          queryArr.push(where('activeInMarketPlace', '==', true));
          queryArr.push(where('usersId', 'array-contains', userDataRedux.uid));
          queryArr.push(orderBy('creationDate', 'desc'));
          // if (docObj) {
          //   queryArr.push(startAfter(startAfterDoc));
          // }
          queryArr.push(limit(8));
        }
        let dataObj = await getDocs(query(...queryArr));

        let dataLen =
          dataObj && dataObj.docs && dataObj.docs.length
            ? dataObj.docs.length
            : 8;

        dataObj.docs.map(async (ele, index) => {
          if (dataLen && dataLen - 1 === index) {
            startAfterDoc = ele;
          }

          let cObj = {
            ...ele.data(),
            id: ele.id,
          };
          if (cObj.isMultiple && Number(cObj.nftQuantity) > 1) {
            let startingPrice = 0;
            let indexCount = 0;

            let acceptAdminState = false;
            let pendingAdminState = false;
            let rejectAdminState = false;

            let allactiveInMarketPlace = false;

            let canBulkRedeem = false;
            let isRedeem = false;
            let redeemCount = 0;

            Object.values(cObj.multipleNftDetails).map((ele, index) => {
              if (ele.adminState === 'ACCEPT' && ele.activeInMarketPlace) {
                if (
                  ele.nftSaleType &&
                  ele.nftSaleType !== 'Auctioning' &&
                  ele.price &&
                  (!startingPrice ||
                    (startingPrice && Number(ele.price) < startingPrice))
                ) {
                  startingPrice = Number(ele.price);
                } else if (
                  ele.nftSaleType &&
                  ele.nftSaleType === 'Auctioning' &&
                  ele.auctionEndTime &&
                  ele.minBiddingPrice &&
                  (!startingPrice ||
                    (startingPrice &&
                      Number(ele.minBiddingPrice) < startingPrice))
                ) {
                  startingPrice = Number(ele.minBiddingPrice);
                }
              }

              if (ele.userId && ele.userId === userDataRedux.uid) {
                indexCount = indexCount + 1;

                if (ele.adminState === 'ACCEPT') {
                  acceptAdminState = true;
                } else if (ele.adminState === 'PENDING') {
                  pendingAdminState = true;
                } else if (ele.adminState === 'REJECT') {
                  rejectAdminState = true;
                }

                if (ele.activeInMarketPlace) {
                  allactiveInMarketPlace = true;
                }

                if (!ele.isRedeem && !ele.activeInMarketPlace) {
                  canBulkRedeem = true;
                }
                if (ele.isRedeem) {
                  redeemCount = redeemCount + 1;
                }
              }
            });

            if (indexCount === redeemCount) {
              isRedeem = true;
            }

            if (props.type === 'redeem') {
              if (redeemCount > 0) {
                nftArr.push({
                  ...cObj,
                  startingPrice: startingPrice,
                  index: indexCount,
                  activeInMarketPlace: allactiveInMarketPlace,
                  acceptAdminState: acceptAdminState,
                  pendingAdminState: pendingAdminState,
                  rejectAdminState: rejectAdminState,
                  canBulkRedeem,
                  isRedeem,
                });
              }
            } else {
              nftArr.push({
                ...cObj,
                startingPrice: startingPrice,
                index: indexCount,
                activeInMarketPlace: allactiveInMarketPlace,
                acceptAdminState: acceptAdminState,
                pendingAdminState: pendingAdminState,
                rejectAdminState: rejectAdminState,
                canBulkRedeem,
                isRedeem,
              });
            }
          } else {
            if (props.type === 'redeem') {
              if (cObj.isRedeem) {
                nftArr.push({ ...cObj });
              }
            } else {
              nftArr.push({ ...cObj });
            }
          }
        });

        if (nftArr.length === backedNftArr.length) {
          sethasMore(false);
          setloadingNfts(false);

          return;
        }

        backedNftArr = [...nftArr];
        setwalletOwnedNfts([...backedNftArr]);
        setloadingNfts(false);
      }
    } catch (err) {
      console.log('getWalletNFTs err', err);
      setloadingNfts(false);
    }
  };

  const redeemNftState = async () => {
    let nftData = walletOwnedNfts[selectedNftIndex];
    let ref = doc(firebaseFireStore, 'musicartNfts', nftData.tokenId);
    updateDoc(ref, {
      isRedeem: true,
    });
    setRedeemState(true);
  };

  // function to Redeem Nft from block chain
  const handleRedeemNft = async () => {
    try {
      console.log('redeem start');
      setRedeemBtnLoading(true);

      let nftData = walletOwnedNfts[selectedNftIndex];
      let tokensArr = [];
      let tokensArrForDb = [];

      if (nftData.isMultiple) {
        Object.values(nftData.multipleNftDetails).map((ele, index) => {
          if (
            ele.userId &&
            ele.userId === userDataRedux.uid &&
            !ele.isRedeem &&
            !ele.activeInMarketPlace
          ) {
            tokensArr.push({
              amount: 1,
              tokenId: nftData.tokenId,
              sn: ele.index,
            });
            tokensArrForDb.push({
              tokenId: nftData.tokenId,
              nftId: ele.nftId,
            });
          }
        });
      } else {
        tokensArr.push({
          amount: 1,
          tokenId: nftData.tokenId,
          sn: 1,
        });
      }

      console.log('tokensArr', tokensArr);

      const redeemResponse = await redeemNfts(tokensArr);
      if (redeemResponse.status === 'error') {
        throw new Error(
          redeemResponse?.message
            ? redeemResponse.message
            : 'Failed to redeem tokens',
        );
      }

      console.log('redeemResponse', redeemResponse);

      //updating db
      let batch = writeBatch(firebaseFireStore);

      if (nftData.isMultiple) {
        console.log('tokensArrForDb', tokensArrForDb);
        tokensArrForDb.map((ele, index) => {
          let tokenSummaryRef = doc(
            firebaseFireStore,
            'musicartNfts',
            ele.tokenId,
          );
          batch.update(tokenSummaryRef, {
            [`multipleNftDetails.${ele.nftId}.isRedeem`]: true,
          });
        });
      } else {
        let tokenSummaryRef = doc(
          firebaseFireStore,
          'musicartNfts',
          nftData.tokenId,
        );
        batch.update(tokenSummaryRef, {
          isRedeem: true,
        });
      }
      await batch.commit();

      setwalletOwnedNfts((prev) => {
        let newArr = [...prev];
        newArr[selectedNftIndex].isRedeem = true;
        return newArr;
      });

      setRedeemBtnLoading(false);
      setRedeemModalIsOpened(false);
      toast.success('NFT redeemed successfully', {
        position: 'bottom-left',
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
      });
    } catch (err) {
      console.log('redeem api err', err);
      toast.error('An error occured', {
        position: 'bottom-left',
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
      });
      setRedeemBtnLoading(false);
    }
  };

  const setSelectedNftIndex = (index) => {
    selectedNftIndex = index;
  };

  const updateSelectedNft = (tokenId, updatedItem = {}) => {
    const walletOwnedNfts = props?.walletOwnedNfts.map((nData) => {
      if (nData.tokenId === tokenId) {
        return { ...nData, ...updatedItem };
      }
      return nData;
    });

    setwalletOwnedNfts(walletOwnedNfts);
  };

  // const hanleOpenNotPublicDialog = (nftIndex, nftData) => {
  //   nftNotPublicDataRef.current = { nftIndex, nftData };
  //   setNftNotPublicDialog(true);
  // };

  const hanleCloseNotPublicDialog = () => {
    setNftNotPublicDialog(false);
  };

  return (
    <div>
      <div className="row row--grid">
        <InfiniteScroll
          loadMore={async () => getWalletNFTs()}
          initialLoad={false}
          hasMore={hasMore}
          threshold={isMobile ? 5000 : 1500}
          style={{ width: '100%' }}
        >
          <div className="row row--grid">
            {(() => {
              if (
                walletOwnedNfts.length === 0 &&
                hasMore === false &&
                !loadingNfts
              ) {
                return <div className="no__result__alert">No result found</div>;
              } else {
                return (
                  <>
                    {walletOwnedNfts.map((ele, index) => {
                      return (
                        <NftsCollectionComponent
                          showPublicOption={ele.isMultiple ? false : true}
                          ele={ele}
                          index={index}
                          setSelectedNftIndex={setSelectedNftIndex}
                          setRedeemModalIsOpened={setRedeemModalIsOpened}
                          setnftTransferDialogState={setnftTransferDialogState}
                          // handleDeleteNft={handleDeleteNft}
                          handleRedeemNft={handleRedeemNft}
                          // hanleOpenNotPublicDialog={hanleOpenNotPublicDialog}
                          updateSelectedNft={updateSelectedNft}
                          type={props.type}
                        />
                      );
                    })}

                    {(() => {
                      if (hasMore) {
                        return skeleTonJson.map((ele, index) => (
                          <div
                            style={{ display: 'block' }}
                            className="turning-screens-discover 2xl:w-2/12 xl:w-5/12 lg:w-3/12 md:w-4/12 "
                            key={'collectionSkeleton' + index}
                          >
                            <div className="card" style={{ display: 'block' }}>
                              <div
                                className="card__cover"
                                style={{ display: 'block' }}
                              >
                                <Skeleton
                                  animation="wave"
                                  style={{
                                    aspectRatio: '1',
                                    borderRadius: 20,
                                    marginBottom: 8,
                                  }}
                                  width="100%"
                                />
                              </div>
                              <Skeleton
                                animation="wave"
                                style={{ marginBottom: 10 }}
                                height={40}
                                width="100%"
                              />

                              <Skeleton
                                animation="wave"
                                style={{ marginBottom: 7 }}
                                height={20}
                                width="40%"
                              />
                              <Skeleton
                                animation="wave"
                                height={30}
                                width="100%"
                              />
                              <div className="flex justify-center ">
                                <Skeleton
                                  animation="wave"
                                  style={{
                                    aspectRatio: '1',
                                    marginTop: 17,
                                    marginRight: 5,
                                  }}
                                  width={70}
                                />
                                <Skeleton
                                  animation="wave"
                                  style={{
                                    aspectRatio: '1',
                                    marginTop: 17,
                                    marginLeft: 5,
                                  }}
                                  width={70}
                                />
                              </div>
                            </div>
                          </div>
                        ));
                      }
                    })()}
                  </>
                );
              }
            })()}
          </div>
        </InfiniteScroll>

        <CouponManageDialog
          dialogState={couponDialogState}
          setdialogState={setcouponDialogState}
          nftDetails={walletOwnedNfts[selectedNftIndex]}
          selectedNftIndex={selectedNftIndex}
          walletOwnedNfts={walletOwnedNfts}
          setwalletOwnedNfts={setwalletOwnedNfts}
        />
        <NftTransferDialog
          dialogState={nftTransferDialogState}
          setdialogState={setnftTransferDialogState}
          selectedNftIndex={selectedNftIndex}
          walletOwnedNfts={walletOwnedNfts}
          setwalletOwnedNfts={setwalletOwnedNfts}
          address={
            userWalletRedux && userWalletRedux.address
              ? userWalletRedux.address
              : []
          }
        />
        <NftNotPublicDialog
          handleClose={hanleCloseNotPublicDialog}
          isOpened={isNftNotPublicDialog}
          activeInMarketPlace={
            nftNotPublicDataRef.current.nftData.activeInMarketPlace
          }
          activeNft={nftNotPublicDataRef.current}
          isNftNotPublicLoading={isNftNotPublicLoading}
          setwalletOwnedNfts={setwalletOwnedNfts}
          walletOwnedNfts={walletOwnedNfts}
          setNftNotPublicLoading={setNftNotPublicLoading}
        />

        <NFTReedem
          handleClose={() => setRedeemModalIsOpened(false)}
          isOpened={redeemModalIsOpened}
          handleDelete={handleRedeemNft}
          redeemBtnLoading={redeemBtnLoading}
        />
      </div>
    </div>
  );
}
